module.exports = __webpack_public_path__ + "static/media/hangouts.024a14c2.png";